import { ROUTES } from 'src/app/shared/constants';
import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  // {
  //   displayName: 'Dashboard',
  //   iconName: 'aperture',
  //   route: '/dashboard'
  // },
  {
    displayName: 'pef database',
    iconName: 'brand-inertia',
    route: ROUTES.USER.PROCESS
  },
  {
    displayName: 'eula',
    iconName: 'file-description',
    route: ROUTES.USER.EULA
  },
  {
    displayName: 'information',
    iconName: 'info-circle',
    route: ROUTES.USER.INFORMATION
  }
];
